import { generateClient } from "aws-amplify/api";
import { createFirmDetails, updateFirmDetails } from "../graphql/mutations";
import { getFirmBySub, listFirmDetails } from "../graphql/queries";

const client = generateClient();

const firmService = {
  add: async (firmData) => {
    const res = await client.graphql({
      query: createFirmDetails,
      variables: {
        input: {
          sub: firmData.sub,
          email: firmData.email,
          businessName: firmData.businessName,
          keyContact: firmData.keyContact,
          phone: firmData.phone,
          addressLine1: firmData.addressLine1,
          addressLine2: firmData.addressLine2,
          postCode: firmData.postCode,
          city: firmData.city,
          state: firmData.state,
          country: firmData.country,
        },
      },
      authMode: "userPool",
    });
    return res.data?.createFirmDetails;
  },
  listFirmDetails: async () => {
    const res = await client.graphql({
      query: listFirmDetails,
      authMode: "userPool",
    });
    return res.data?.listFirmDetails?.items[0];
  },
  updateFirmDetails: async (firmData) => {
    const updateFirm = await client.graphql({
      query: updateFirmDetails,
      variables: {
        input: {
          id: firmData.id,
          email: firmData.businessEmail,
          businessName: firmData.businessName,
          keyContact: firmData.keyContact,
          phone: firmData.phone,
          addressLine1: firmData.addressLine1,
          addressLine2: firmData.addressLine2,
          postCode: firmData.postCode,
          city: firmData.city,
          state: firmData.state,
        },
      },
      authMode: "userPool",
    });
    return updateFirm?.data?.updateFirmDetails;
  },
  getFirmBySub: async (sub) => {
    const res = await client.graphql({
      query: getFirmBySub,
      variables: {
        sub,
      },
      authMode: "userPool",
    });
    return res.data?.getFirmBySub?.items[0];
  },
};

export default firmService;
